export const maxRetries = 5
